<template>
    <v-container fluid class="fill-height" style="background-color: #f5f5f5;">
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="6" lg="4">
                <v-card class="pa-6" outlined>
                    <div class="text-center mb-4">
                        <v-img v-if="logo" :src="logo" max-width="80" class="mx-auto mb-4"></v-img>
                        <h2 class="text-h5 font-weight-bold">External Examiner Access</h2>
                    </div>

                    <div v-if="verifying" class="text-center py-4">
                        <v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
                        <p class="mt-4 mb-0">Verifying your login link...</p>
                    </div>

                    <div v-else-if="error" class="text-center py-4">
                        <v-icon color="error" size="48">mdi-alert-circle-outline</v-icon>
                        <p class="error--text mt-4 mb-0">{{ error }}</p>
                        <p class="text-caption mt-2">This link may have expired or already been used.</p>
                    </div>

                    <div v-else-if="success" class="text-center py-4">
                        <v-icon color="success" size="48">mdi-check-circle-outline</v-icon>
                        <p class="success--text mt-4 mb-0">Login successful.</p>
                        <p class="mt-2 mb-0">Redirecting you to the portal...</p>
                    </div>

                    <div v-else class="text-center py-4">
                        <v-icon color="warning" size="48">mdi-link-variant-off</v-icon>
                        <p class="mt-4 mb-0">No login token found.</p>
                        <p class="text-caption mt-2">Please use the link sent to your email.</p>
                    </div>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Api from "@/main/api";
import Links from "@/shared/constants/Links";
import Defaults from "@/shared/Defaults";
import LoginUtil from "@/login/LoginUtil";

export default {
    name: "ExternalExaminerAuth",

    data: () => ({
        verifying: false,
        success: false,
        error: '',
        logo: ''
    }),

    created() {
        this.logo = Defaults.api + Links.global.logo;
        this.verifyToken();
    },

    methods: {
        getTokenFromUrl() {
            const params = new URLSearchParams(window.location.search);
            return params.get('token');
        },

        verifyToken() {
            const token = this.getTokenFromUrl();
            if (!token) {
                return;
            }

            this.verifying = true;
            Api.auth.verifyExternalExaminerMagicLink(token)
                .then(async (res) => {
                    const data = res.data || {};
                    await LoginUtil.setAccessToken(data.jwt);
                    await LoginUtil.setRefreshToken(data.refreshToken);
                    this.success = true;
                    this.redirectToPortal();
                })
                .catch((err) => {
                    this.error = err?.response?.data?.message || 'Invalid or expired link';
                })
                .finally(() => {
                    this.verifying = false;
                });
        },

        redirectToPortal() {
            setTimeout(() => {
                window.location.href = '/officer/#/evaluation/evaluations';
            }, 1500);
        }
    }
}
</script>

<style scoped>
.fill-height {
    min-height: 100vh;
}
</style>
